import { isNilOrEmpty } from 'helpers';

import { EntityWithConnectionCountsFragment } from 'generated/graphql';

export function extractConnectionCountByEntityTypeId(
  entityTypeId: string,
  entity: EntityWithConnectionCountsFragment
) {
  // no entity type id
  if (isNilOrEmpty(entityTypeId)) {
    return null;
  }

  // Find connection to the current entity
  // that is connected to the default entity type

  // If this entity is the default type, both sides must be the default
  // Eg People --> People
  if (entityTypeId === entity.entityTypeId) {
    return entity.entityConnectionCount
      .filter(x => x.entityConnectionType.entityType1Id === entity.entityTypeId)
      .find(x => x.entityConnectionType.entityType2Id === entity.entityTypeId);

  }

  // Otherwise just one side needs to match
  return entity.entityConnectionCount
    .find(x =>
      [x.entityConnectionType.entityType1Id, x.entityConnectionType.entityType2Id]
        .includes(entityTypeId)
    );
}

/**
 * Returns the active connections count for connections to the
 * the given entity type
 *
 * @param entityTypeId The entity type the entity is connected to
 * @param entity The entity to check
 */
export function extractActiveConnectionCountByEntityTypeId(
  entityTypeId: string,
  entity: EntityWithConnectionCountsFragment
): number {
  return extractConnectionCountByEntityTypeId(entityTypeId, entity)?.activeConnectionsCount;
}
